/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Event_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Event Lines" |
*
* @param {Style_Guide_Manager_Max_Event_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_event_lines_label = /** @type {((inputs?: Style_Guide_Manager_Max_Event_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Event_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes maximum par evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Ereignislinien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linee di eventi massimi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество линий событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximas líneas de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大事件线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大イベントライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम घटना रेखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de linhas de eventos")
	return /** @type {LocalizedString} */ ("Maximum Event Lines")
});